var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-layout",
        {
          directives: [
            {
              name: "resize",
              rawName: "v-resize",
              value: _vm.onResize,
              expression: "onResize"
            }
          ],
          staticClass: "data-table-layout",
          attrs: { column: "" }
        },
        [
          _c(
            "v-data-table",
            {
              staticClass: "elevation-1",
              class: { mobile: _vm.isMobile },
              attrs: {
                "item-key": "caseId",
                headers: _vm.headers,
                items: _vm.caseData,
                "items-per-page": 5,
                expand: _vm.expand,
                "hide-headers": _vm.isMobile,
                "disable-initial-sort": true
              },
              scopedSlots: _vm._u([
                {
                  key: "items",
                  fn: function(props) {
                    return [
                      !_vm.isMobile
                        ? _c(
                            "tr",
                            {
                              key: props.item.caseId,
                              on: {
                                click: function($event) {
                                  return _vm.expandAttendanceCloseCase(props)
                                }
                              }
                            },
                            [
                              _vm.gcs
                                ? _c("td", { staticClass: "text-xs-left" }, [
                                    _vm._v(
                                      _vm._s(props.item.recordId) +
                                        "\n          "
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(_vm._s(props.item.caseDescriptionShort))
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-xs-left" }, [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(props.item.caseClosed) +
                                    "\n          "
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-xs-left" }, [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(props.item.caseGroup1) +
                                    "\n          "
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-xs-left" }, [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(props.item.caStDescription) +
                                    "\n          "
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-xs-left" }, [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(props.item.staffSignature) +
                                    "\n          "
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-xs-left" }, [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(props.item.createDate) +
                                    "\n          "
                                )
                              ]),
                              _vm._v(" "),
                              !_vm.gcs
                                ? _c("td", { staticClass: "text-xs-left" }, [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(
                                          props.item.caseInvMarkDescription
                                        ) +
                                        "\n          "
                                    )
                                  ])
                                : _vm._e()
                            ]
                          )
                        : _c(
                            "v-card",
                            {
                              staticClass: "responsive-card",
                              staticStyle: { margin: "16px" }
                            },
                            [
                              _c(
                                "tr",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.expandAttendanceCloseCase(
                                        props
                                      )
                                    }
                                  }
                                },
                                [
                                  _c("td", [
                                    _c("ul", { staticClass: "flex-content" }, [
                                      _c(
                                        "li",
                                        {
                                          staticClass: "flex-item",
                                          attrs: {
                                            "data-label": "Beschreibung"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                props.item.caseDescriptionShort
                                              ) +
                                              "\n                "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "li",
                                        {
                                          staticClass: "flex-item",
                                          attrs: {
                                            "data-label": "Geschlossen am"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(props.item.caseClosed) +
                                              "\n                "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "li",
                                        {
                                          staticClass: "flex-item",
                                          attrs: { "data-label": "Produkt" }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(props.item.caseGroup1) +
                                              "\n                "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "li",
                                        {
                                          staticClass: "flex-item",
                                          attrs: { "data-label": "Status" }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                props.item.caStDescription
                                              ) +
                                              "\n                "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "li",
                                        {
                                          staticClass: "flex-item",
                                          attrs: { "data-label": "Zuständig" }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                props.item.staffSignature
                                              ) +
                                              "\n                "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "li",
                                        {
                                          staticClass: "flex-item",
                                          attrs: { "data-label": "Eröffnet am" }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(props.item.createDate) +
                                              "\n                "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "li",
                                        {
                                          staticClass: "flex-item",
                                          attrs: {
                                            "data-label":
                                              "Abrechnungskennzeichen"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                props.item
                                                  .caseInvMarkDescription
                                              ) +
                                              "\n                "
                                          )
                                        ]
                                      )
                                    ])
                                  ])
                                ]
                              )
                            ]
                          )
                    ]
                  }
                },
                {
                  key: "expand",
                  fn: function(props) {
                    return [
                      _c(
                        "v-card",
                        { attrs: { flat: "" } },
                        [
                          _c(
                            "v-card-text",
                            [
                              _c(
                                "v-data-table",
                                {
                                  staticClass: "elevation-10",
                                  class: { mobile: _vm.isMobile },
                                  attrs: {
                                    headers: _vm.subHeaders,
                                    items: props.item.attendance,
                                    "item-key": "caseId",
                                    "rows-per-page-items": [
                                      10,
                                      30,
                                      50,
                                      { text: "All", value: -1 }
                                    ],
                                    "hide-headers": _vm.isMobile
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "items",
                                        fn: function(subprops) {
                                          return [
                                            !_vm.isMobile
                                              ? _c("tr", [
                                                  _c("td", [
                                                    _vm._v(
                                                      _vm._s(
                                                        subprops.item
                                                          .staffSignature
                                                      )
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-xs-left"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                    " +
                                                          _vm._s(
                                                            subprops.item
                                                              .caTcDescription
                                                          ) +
                                                          "\n                  "
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-xs-left"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                    " +
                                                          _vm._s(
                                                            subprops.item
                                                              .caTcStart
                                                          ) +
                                                          "\n                  "
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-xs-left"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                    " +
                                                          _vm._s(
                                                            subprops.item.hour
                                                          ) +
                                                          "\n                  "
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-xs-left"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                    " +
                                                          _vm._s(
                                                            subprops.item
                                                              .caTcEnd
                                                          ) +
                                                          "\n                  "
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-xs-left"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                    " +
                                                          _vm._s(
                                                            subprops.item
                                                              .caTcHours
                                                          ) +
                                                          "\n                  "
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-xs-left"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                    " +
                                                          _vm._s(
                                                            subprops.item
                                                              .caTcHoursFree
                                                          ) +
                                                          "\n                  "
                                                      )
                                                    ]
                                                  )
                                                ])
                                              : _c(
                                                  "tr",
                                                  { staticClass: "nested-row" },
                                                  [
                                                    _c("td", [
                                                      _c(
                                                        "ul",
                                                        {
                                                          staticClass:
                                                            "flex-content"
                                                        },
                                                        [
                                                          _c(
                                                            "li",
                                                            {
                                                              staticClass:
                                                                "flex-item",
                                                              attrs: {
                                                                "data-label":
                                                                  "Mitarbeitername"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                        " +
                                                                  _vm._s(
                                                                    subprops
                                                                      .item
                                                                      .staffSignature
                                                                  ) +
                                                                  "\n                      "
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "li",
                                                            {
                                                              staticClass:
                                                                "flex-item",
                                                              attrs: {
                                                                "data-label":
                                                                  "Beschreibung"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                        " +
                                                                  _vm._s(
                                                                    subprops
                                                                      .item
                                                                      .caTcDescription
                                                                  ) +
                                                                  "\n                      "
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "li",
                                                            {
                                                              staticClass:
                                                                "flex-item",
                                                              attrs: {
                                                                "data-label":
                                                                  "Datum(Startzeit)"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                        " +
                                                                  _vm._s(
                                                                    subprops
                                                                      .item
                                                                      .caTcStart
                                                                  ) +
                                                                  "\n                      "
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "li",
                                                            {
                                                              staticClass:
                                                                "flex-item",
                                                              attrs: {
                                                                "data-label":
                                                                  "Uhrzeit (Startzeit)"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                        " +
                                                                  _vm._s(
                                                                    subprops
                                                                      .item.hour
                                                                  ) +
                                                                  "\n                      "
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "li",
                                                            {
                                                              staticClass:
                                                                "flex-item",
                                                              attrs: {
                                                                "data-label":
                                                                  "Endezeit"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                        " +
                                                                  _vm._s(
                                                                    subprops
                                                                      .item
                                                                      .caTcEnd
                                                                  ) +
                                                                  "\n                      "
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "li",
                                                            {
                                                              staticClass:
                                                                "flex-item",
                                                              attrs: {
                                                                "data-label":
                                                                  "Dauer"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                        " +
                                                                  _vm._s(
                                                                    subprops
                                                                      .item
                                                                      .caTcHours
                                                                  ) +
                                                                  "\n                      "
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "li",
                                                            {
                                                              staticClass:
                                                                "flex-item",
                                                              attrs: {
                                                                "data-label":
                                                                  "Freiminuten"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                        " +
                                                                  _vm._s(
                                                                    subprops
                                                                      .item
                                                                      .caTcHoursFree
                                                                  ) +
                                                                  "\n                      "
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ])
                                                  ]
                                                )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                },
                                [
                                  _vm._v(" "),
                                  _c("template", { slot: "no-data" }, [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: { "text-align": "center" }
                                      },
                                      [_vm._v("Keine Daten vorhanden")]
                                    )
                                  ])
                                ],
                                2
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  }
                }
              ])
            },
            [
              _vm._v(" "),
              _vm._v(" "),
              _c("template", { slot: "no-data" }, [
                _c("div", { staticStyle: { "text-align": "center" } }, [
                  _vm._v("Keine Daten vorhanden")
                ])
              ])
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }